
import store from '../store'

export const keyCodes ={
  TOKEN : 'token',
  /**
   * 字典-就诊类型
   */
  DICT_CODES_TREATMENT_TYPE : 10,
  /**
   * pdf（base64）文件类型
   */
  FILE_CONTENT_TYPE_PDF_BASE64 : 'data:application/pdf;base64,',
  /**
   * 通过通用登陆界面进入系统
   */
  LOGIN_BY_COMMON: 1,
  /**
   * 通过昆明登陆界面进入系统
   */
  LOGIN_BY_KM: 2,
  /**
   * 通过南海妇幼登陆界面进入系统
   */
  LOGIN_BY_NHFY: 3,
  /**
   * 通过省妇幼登陆界面进入系统
   */
  LOGIN_BY_SFY: 4,
  /**
   * 快速查询的 系统参数配置编码
   */
  QUICK_SEARCH_SETTING_CODE: '100',
  /**
   * 自检、外送 系统参数配置编码
   */
  SPEC_SOURCE_SETTING_CODE: '200',
  /**
   * 自检报告 编码
   */
  TEST_REPORT_CODE: '2001001',
  /**
   * 外检报告
   */
  TEST_REPORT_CODE_OUT: '2001002',
}
/**
 * 数据字典
 */
export const dictionaryDatas = {
  specStatusList : [
    {id: '137', text: '已准备'},
    {id: '143', text: '部分完成'},
    {id: '145', text: '全部完成'},
    {id: '302', text: '退单'},
    {id: '401', text: '迟发'}
  ],
  paperSizeList : [
    {id: '0', text: 'A5'},
    {id: '1', text: 'A4'},
    {id: '2', text: 'A3'}
  ],
  quickSearchItems: [
    {id: '1001001', text: '最近1天检查情况', value: 1},
    {id: '1001002', text: '最近3天检查情况', value: 3},
    {id: '1001003', text: '最近1周检查情况', value: 7}
  ],
  specimenSourceList: [
    {id: keyCodes.TEST_REPORT_CODE, text: '自检报告'},
    {id: keyCodes.TEST_REPORT_CODE_OUT, text: '外检报告'}
  ]
}

/**
 * 重置本地缓存
 */
export function resetLocalCache() {
  store.dispatch('setUserInfo', null);//清除登陆信息
  store.dispatch('setAreaOrgs', null);//清除区域机构
  //store.dispatch('setLoginBy', null);//清除通过哪个界面登陆，不清除，缓存上次登陆的
}

/**
 * 通过 lossless-json 反序化时的（long）数字转换函数
 * @param key
 * @param value
 * @returns {*}
 */
export function convertLosslessNumber (key, value) {
  if (value && value.isLosslessNumber) {
    return value.value;
  }
  else {
    return value;
  }
}



// WEBPACK FOOTER //
// ./src/commons/index.js